import { minToHourConverter } from "@/helpers/useCommonFunctions";
import { CardFooter, Text } from "@dxp-feed/ui";

const CardFoot = ({ item }: { item: any }) => {
  return (
    <CardFooter className="!pt-0 !border-t-0 absolute bottom-0">
      <Text as="ul" className="flex gap-[18px]">
        {item?.preparationTime ? (
          <Text as="li" className="flex items-center gap-1">
            <Text
              as="span"
              className="demo-icon icon-clock w-[27px] h-[27px] text-[22px] flex items-center justify-center "
            ></Text>
            {minToHourConverter(item?.preparationTime)}
          </Text>
        ) : (
          ""
        )}
      </Text>
    </CardFooter>
  );
};
export default CardFoot;
